import { JsClientEngine2d6599fsx5fyf as JsClientEngine } from './JsClientEngine.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HttpClientEngineConfig53hvl3zmhf7d as HttpClientEngineConfig } from '../HttpClientEngineConfig.mjs';
import { engines_getInstance1y1q23sy4bogu as engines_getInstance } from '../Loader.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_initHook() {
  return initHook;
}
var initHook;
var JsClass;
function Js() {
  if (JsClass === VOID) {
    class $ {
      q5w(block) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (JsClientEngineConfig())();
        block(this_0);
        return new (JsClientEngine())(this_0);
      }
      c5i(block) {
        return this.q5w(block);
      }
      toString() {
        return 'Js';
      }
      hashCode() {
        return -527824213;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Js()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Js');
    JsClass = $;
  }
  return JsClass;
}
var Js_instance;
function Js_getInstance() {
  return Js_instance;
}
function JsClientEngineConfig$requestInit$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var JsClientEngineConfigClass;
function JsClientEngineConfig() {
  if (JsClientEngineConfigClass === VOID) {
    class $ extends HttpClientEngineConfig() {
      constructor() {
        super();
        var tmp = this;
        tmp.v5w_1 = JsClientEngineConfig$requestInit$lambda;
        this.w5w_1 = Object.create(null);
      }
    }
    initMetadataForClass($, 'JsClientEngineConfig', JsClientEngineConfig);
    JsClientEngineConfigClass = $;
  }
  return JsClientEngineConfigClass;
}
function initHook$init$() {
  engines_getInstance().y5w(Js_instance);
  return Unit_instance;
}
//region block: init
Js_instance = new (Js())();
//endregion
//region block: eager init
initHook = initHook$init$();
//endregion
//region block: exports
export {
  Js_instance as Js_instance94aldsayunvq,
  get_initHook as get_initHook9u2azug2lqjy,
};
//endregion

//# sourceMappingURL=Js.mjs.map
